import { Skeleton, Card, cn } from "ui";

type DetailPageSkeletonProps = {
  /** Number of label/value groups in the top summary card. */
  summaryItems?: number;
  /** Number of section cards in the main (2/3) column. */
  sections?: number;
  /** Number of label/value rows per section card. */
  rowsPerSection?: number;
  className?: string;
};

export const PaymentDetailsSkeleton = ({
  summaryItems = 5,
  sections = 2,
  rowsPerSection = 10,
  className,
}: DetailPageSkeletonProps) => (
  <div className={cn("self-stretch", className)}>
    {/* Top summary card */}
    <Card disableHover className="mb-6 flex flex-wrap gap-x-16 gap-y-6">
      {Array.from({ length: summaryItems }).map((_, i) => (
        <div key={i} className="flex flex-col gap-2">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-4 w-24" />
        </div>
      ))}
    </Card>

    <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
      {/* Left: section cards with label/value rows */}
      <div className="flex flex-col gap-8 lg:col-span-2">
        {Array.from({ length: sections }).map((_, i) => (
          <Card key={i} disableHover className="overflow-hidden p-0">
            <div className="flex items-center justify-between border-b border-foundations-subtle p-6">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-5 w-5" />
            </div>

            <div className="flex flex-col gap-6 p-6">
              {Array.from({ length: rowsPerSection }).map((_, rowIndex) => (
                <div
                  key={rowIndex}
                  className="flex items-center justify-between gap-4"
                >
                  <Skeleton className="h-3 w-32" />
                  <Skeleton
                    className={cn("h-3", rowIndex % 2 === 0 ? "w-40" : "w-24")}
                  />
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>

      {/* Right: timeline card */}
      <Card disableHover className="flex flex-col gap-6">
        <Skeleton className="h-4 w-24" />
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-start gap-3">
            <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-3 w-1/2" />
              <Skeleton className="h-3 w-1/3" />
            </div>
          </div>
        ))}
      </Card>
    </div>
  </div>
);
